package com.bikompanion.ui.strings

val CaBikompanionStrings = object : BikompanionStrings {
    override val actionRetry = "Torna-ho a provar"
    override val actionClose = "Tanca"
    override val actionSubmit = "Envia"
    override val detailsLabel = "Detalls"
    override val detailsShow = "Mostra els detalls"
    override val detailsHide = "Amaga els detalls"
    override val actionGetDirections = "Com arribar-hi"
    override val actionShareStation = "Comparteix l'estació"
    override val linkCopied = "Enllaç copiat"
    override val locateShow = "Mostra la meva ubicació"
    override val locateFollowHeading = "Segueix la meva orientació"
    override val locateStopFollowing = "Deixa de seguir-me"
    override val settingsTitle = "Configuració"
    override val actionBack = "Enrere"
    override val settingsAppearance = "Aparença"
    override val settingsLanguage = "Idioma"
    override val languageSystem = "Predeterminat del sistema"
    override val themeSystem = "Sistema"
    override val themeLight = "Clar"
    override val themeDark = "Fosc"
    override val settingsNotifications = "Notificacions"
    override val stationAlerts = "Alertes d'estacions"
    override val notificationsOn = "Activades: t'avisarem quan una estació vigilada tingui una bici"
    override val notificationsOff = "Desactivades: les estacions vigilades no et poden avisar"
    override val notificationsBlocked = "Bloquejades: permet les notificacions a la configuració del lloc al navegador"
    override val actionManage = "Gestiona"
    override val actionTurnOn = "Activa"
    override val settingsSupport = "Ajuda"
    override val sendFeedback = "Envia comentaris"
    override val sendFeedbackDescription = "Explica'ns un problema o una dada incorrecta d'una estació"
    override val shareApp = "Comparteix l'app"
    override val settingsAbout = "Quant a"
    override val aboutApp = "Quant a Bikompanion"
    override val aboutDevelopedBy = "Desenvolupada per Tiago Araujo"
    override val aboutDataSources = "Fonts de dades"
    override val sourceCityBikesDescription = "Xarxes de bicis compartides de tot el món"
    override val sourceGbfsTitle = "Feeds GBFS dels operadors"
    override val sourceGbfsDescription = "Dades en directe de les estacions dels operadors"
    override val sourceOsmTitle = "Col·laboradors d'OpenStreetMap"
    override val sourceOsmDescription = "Aparcabicis i dades del mapa"
    override val sourceCartoDescription = "Mosaics del mapa"
    override val aboutLegal = "Legal"
    override val licensesTitle = "Llicències de codi obert"
    override val privacyPolicy = "Política de privadesa"
    override val deleteRatings = "Esborra les meves valoracions"
    override val deleteRatingsDescription = "Ens envia el teu identificador anònim per correu perquè les esborrem"
    override val licensesLoadFailed = "No s'ha pogut carregar la llista de llicències"
    override val aboutVersion = { version: String -> "Versió $version" }
    override val issueFlatTire = "Roda punxada"
    override val issueFrontBrake = "El fre davanter no funciona"
    override val issueRearBrake = "El fre del darrere no funciona"
    override val issueChain = "La cadena se surt"
    override val issueGears = "Els canvis no funcionen"
    override val issueSeat = "Selló malmès o absent"
    override val issueLights = "Els llums no funcionen"
    override val issueLockOrBasket = "Cadenat o cistella malmesos"
    override val issueFrame = "Quadre malmès"
    override val issueMotor = "El motor elèctric no funciona"
    override val issueBattery = "La bateria no carrega"
    override val issueOther = "Altres"
    override val networksLoadFailed = "No s'han pogut carregar les xarxes de bicis. Comprova la connexió."
    override val parkingLoadFailed = "No s'ha pogut carregar l'aparcament de bicis"
    override val parkingLoading = "S'està cercant aparcament de bicis…"
    override val stationsLoading = "S'estan carregant les estacions…"
    override val noNetworkHereTitle = "Aquí no hi ha bicis compartides"
    override val noNetworkHereHint = "Allunya el mapa per trobar la xarxa més propera"
    override val installTitle = "Instal·la Bikompanion"
    override val installHintIos = "Toca Comparteix i després Afegeix a la pantalla d'inici."
    override val installHintAndroid = "Aconsegueix l'app a Google Play."
    override val actionInstall = "Instal·la"
    override val parkingTypeStands = "Aparcabicis"
    override val parkingTypeShed = "Caseta per a bicis"
    override val parkingTypeLockers = "Armariets per a bicis"
    override val parkingTypeBuilding = "Edifici per a bicis"
    override val parkingTypeOther = "Aparcament de bicis"
    override val fieldAddress = "Adreça"
    override val fieldCovered = "Cobert"
    override val fieldYes = "Sí"
    override val fieldNo = "No"
    override val fieldId = "ID"
    override val fieldStationId = "ID de l'estació"
    override val fieldCoordinates = "Coordenades"
    override val fieldCapacity = "Capacitat"
    override val fieldNetwork = "Xarxa"
    override val fieldName = "Nom"
    override val fieldCity = "Ciutat"
    override val fieldCountry = "País"
    override val fieldCompany = "Empresa"
    override val fieldLicense = "Llicència"
    override val fieldLicenseUrl = "URL de la llicència"
    override val availabilityBikes = "Bicis"
    override val availabilityElectric = "Elèctriques"
    override val availabilityEmpty = "Lliures"
    override val bicingNextPickup = { p0: String -> "Propera recollida de Bicing d'aquí a $p0" }
    override val rateTitle = "Consulta o valora una bici"
    override val rateFindingNetworks = "S'estan cercant xarxes de bicis a prop teu…"
    override val rateWhatsWrong = "Què li passa?"
    override val rateBikeNumber = "Número de bici"
    override val rateElectricBike = "Bici elèctrica"
    override val rateVoteBad = "Dolenta"
    override val rateVoteGood = "Bona"
    override val rateWhichNetwork = "De quina xarxa és aquesta bici?"
    override val refreshRateLimited = "S'ha arribat al límit de sol·licituds; es tornarà a provar automàticament"
    override val refreshFailed = "No s'ha pogut actualitzar"
    override val refreshNextUpdate = { p0: Int -> "Propera actualització d'aquí a $p0 s" }
    override val refreshUpdating = "S'està actualitzant…"
    override val dataNone = "Encara no hi ha dades"
    override val dataAgeJustNow = "Dades de fa un moment"
    override val dataAgeMinutes = { p0: Int -> "Dades de fa $p0 min" }
    override val dataAgeHours = { p0: Int -> "Dades de fa $p0 h" }
    override val dataAgeDays = { p0: Int -> "Dades de fa $p0 d" }
    override val actionOpenOperator = { p0: String -> "Obre $p0" }
    override val watchNormal = "Vigila les bicis normals"
    override val watchElectric = "Vigila les bicis elèctriques"
    override val watchInstallNormal = "Instal·la l'app per vigilar bicis normals"
    override val watchInstallElectric = "Instal·la l'app per vigilar bicis elèctriques"
    override val watchStopNormal = "Deixa de vigilar les bicis normals"
    override val watchStopElectric = "Deixa de vigilar les bicis elèctriques"
    override val actionCheckRateBike = "Consulta / Valora la bici"
    override val layerStations = "Estacions"
    override val layerParking = "Aparcabicis"
    override val mapLabelBikes = { p0: Int -> "$p0 bicis" }
    override val mapLabelEbikes = { p0: Int -> "$p0 elèctriques" }
    override val mapLabelFree = { p0: Int -> "$p0 lliures" }
    override val scoreHeadline = { p0: String, p1: String -> "Bici $p0 · $p1" }
    override val scoreNoRatings = "Encara no hi ha valoracions. Pots afegir la primera."
    override val scoreLooksGood = "Té bona pinta."
    override val scoreHasProblems = "Altres persones han tingut problemes amb aquesta bici."
    override val scoreMixed = "Opinions diverses."
    override val ratingNetworkRequired = "Primer tria a quina xarxa pertany aquesta bici."
    override val ratingThanks = { p0: String -> "Gràcies per valorar la bici $p0!" }
    override val ratingCooldown = { p0: Int -> "Ja has valorat aquesta bici fa poc. Torna-ho a provar d'aquí a $p0 min." }
    override val ratingQueued = "Desat: ho enviarem quan tornis a tenir connexió."
    override val ratingInvalidBike = "Aquest número de bici no és vàlid per a aquesta xarxa."
    override val ratingRejected = "No s'ha pogut desar la valoració. Torna-ho a provar més tard."
    override val notificationFoundTitle = "Bici disponible"
    override val notificationFoundNormal = { p0: String -> "Bici normal disponible a $p0" }
    override val notificationFoundElectric = { p0: String -> "Bici elèctrica disponible a $p0" }
    override val notificationExpiredTitle = "Vigilància de l'estació finalitzada"
    override val notificationExpiredNormal = { p0: String -> "S'ha deixat de vigilar les bicis normals a $p0 després de 30 minuts" }
    override val notificationExpiredElectric = { p0: String -> "S'ha deixat de vigilar les bicis elèctriques a $p0 després de 30 minuts" }
    override val channelWatchAlertsName = "Avisos de vigilància d'estacions"
    override val channelWatchAlertsDescription = "Disponibilitat de bicis i novetats de les estacions vigilades"
    override val channelBackgroundWatchName = "Vigilància d'estacions en segon pla"
    override val notificationWatchingTitle = "S'estan vigilant estacions de bicis"
    override val notificationWatchingText = "S'estan vigilant les estacions triades en segon pla"
    override val scoreFewRatings = { count: Int ->
        singularOrPlural(
            count,
            "Només $count valoració de moment.",
            "Només $count valoracions de moment.",
        )
    }
    override val scorePositiveRides = { percent: Int, count: Int ->
        singularOrPlural(
            count,
            "$percent% positiu en $count viatge recent",
            "$percent% positiu en els darrers $count viatges",
        )
    }
}
